import React from 'react';
import cn from 'classnames';
import { ExternalLink } from 'lucide-react';

const styles = {
  wrap: 'mx-auto flex w-[59%] flex-col items-start justify-start rounded-xl bg-gray-100 p-6 mb-3',
  heading: 'text-left text-lg font-bold text-brand-navy',
  list: 'flex w-full flex-col gap-2',
  item: 'text-sm leading-6 text-gray-700',
  link: 'text-blue-600 underline transition-all hover:font-semibold hover:text-blue-800',
  externalIndicator: 'ml-1 inline-block text-xs',
};

type ContactInfo = {
  school: string;
  url: string;
};

type ModalContactLinksPanelProps = {
  contacts: ContactInfo[];
};

const ModalContactLinksPanel = ({ contacts }: ModalContactLinksPanelProps) => {
  if (!contacts || contacts.length === 0) {
    return null;
  }

  return (
    <div id='contact-wrap' className={cn(styles.wrap)}>
      <div className={cn(styles.heading)}>Financial Aid Contact Information</div>
      <div id='financial-aid-contact-list' className={cn(styles.list)}>
        {contacts.map((contact) => (
          <div key={contact.school} className={cn(styles.item)}>
            <a href={contact.url} target='_blank' rel='noopener noreferrer' className={cn(styles.link)}>
              {contact.school}
              <span className={cn(styles.externalIndicator)} aria-label='Opens in new tab'>
                <ExternalLink size={20} className={cn('pt-2')} />
              </span>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ModalContactLinksPanel;
